import { IInfoCategoryMasterData } from '@Domains/MasterData';
import { IUploadImage } from '@Domains/UploadImage';
import {
  CompleteSectionFormValues,
  IntroductionFormValues,
  OtherExplanationsFormValues,
  RemarkFormValues,
} from '@Utils/Types/FormValuesTypes';

export interface IImpactsOnStakeholdersFormValues {
  id?: number;
  introduction?: IntroductionFormValues;
  businessValueChain?: BusinessValueChainFormValues;
  stakeholderAnalysis?: StakeholderAnalysisFormValues;
  otherDescriptions?: OtherExplanationsFormValues[];
  remark?: RemarkFormValues;
  completedSection?: CompleteSectionFormValues;
}

export type BusinessValueChainFormValues = {
  introduction?: IntroductionFormValues;
  descriptionTh?: string;
  descriptionEn?: string;
  remark?: RemarkFormValues;
  assets?: Array<IUploadImage>;
  completedSection?: CompleteSectionFormValues;
};

export enum StakeholderType {
  INTERNAL = 'INTERNAL',
  EXTERNAL = 'EXTERNAL',
}

export type CategoryMasterDataFormValues = {
  id?: number;
  infoCategoryMasterDataId?: number;
  nameTh: string;
  nameEn: string;
};

export type StakeholderGroupFormValues = {
  id?: number;
  stakeholderType: StakeholderType;
  stakeholders: Array<CategoryMasterDataFormValues>;
  otherStakeholders?: Array<CategoryMasterDataFormValues>;
  expectationDescriptionTh: string;
  expectationDescriptionEn: string;
  respondingToExpectationTh?: string;
  respondingToExpectationEn?: string;
  communicationActivities?: Array<CategoryMasterDataFormValues>;
  otherCommunicationActivities?: Array<CategoryMasterDataFormValues>;
  assets?: Array<IUploadImage>;
};

export type StakeholderAnalysisFormValues = {
  introduction?: IntroductionFormValues;
  additionalDescriptionTh: string;
  additionalDescriptionEn: string;
  stakeholderGroups: Array<StakeholderGroupFormValues>;
  remark?: RemarkFormValues;
  completedSection?: CompleteSectionFormValues;
  assets?: Array<IUploadImage>;
};

export type ModalCheckboxListProps = {
  header: string;
  subTitle?: string;
  selectTitle?: string;
  otherTitle?: string;
  required?: boolean;
  value: IInfoCategoryMasterData[];
  textAlign?: string;
  otherName: string;
  onChange: (selectedIds: { infoCategoryMasterDataId: string }[]) => void;
};
